import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcIngestions = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "d0783e__feather d0783e__feather-upload-cloud",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polyline", { points: "16 16 12 12 8 16" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 12,
			x2: 12,
			y2: 21
		}),
		/* @__PURE__ */ _jsx("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }),
		/* @__PURE__ */ _jsx("polyline", { points: "16 16 12 12 8 16" })
	]
});
export default SvgIcIngestions;
